import { Anchor } from '@wrisk/ui-components'
import React, { FunctionComponent, PropsWithChildren } from 'react'

export const SignIn: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <Anchor style={{ textDecoration: 'underline' }} href='/sign-in'>
    {children}
  </Anchor>
)
